import { NotificationType } from "../utilities/enums";
import store from "../../store";
import EventBus from "../utilities/eventBus.js";

export const listener = function(vendorInfo, vm) {
  return {
    status: function(status) {
      console.log(status);
    },
    message: function(message) {
      let channelName = message.actualChannel
        ? message.actualChannel
        : message.subscribedChannel;
      if (!channelName || !message.message) return;
      if (vendorInfo.Channels.indexOf(channelName) >= 0) {
        handleControlMessage(message.message, vm);
      }
    },
    presence: function(presence) {
      console.log(presence);
    }
  };
};

export const subscriber = function(vendorInfo, vm) {
  return {
    channels: vendorInfo.Channels,
    channelGroups: vendorInfo.ChannelGroups,
    message: function(message, envelope, channelOrGroup, time, channel) {
      console.log(message);
    },
    error: function(error) {
      console.log(error);
    }
  };
};

function handleControlMessage(message, vm) {
  var notificationType = null;
  var notification = null;

  if (message && message.msg)
    //Via listener
    notification = message.msg;
  if (message.rtid) notificationType = message.rtid;

  // if (notification && notification.TotalBadgeCount) {
  //   vm.InboxCount =  notification.TotalBadgeCount
  //   vm.MessagesCount = notification.TotalMessageCount
  //   vm.Processes = notification.TotalRequestCount
  // }

  if (
    notificationType === NotificationType.AccountUserResponse ||
    notificationType === NotificationType.UserResponse ||
    notificationType === NotificationType.AccountUserInfoMessage ||
    notificationType === NotificationType.UserInfoMessage
  ) {
    if (!notification.Id && notification.UserId)
      notification.Id = notification.UserId;
    else if (notification.Id && !notification.UserId)
      notification.UserId = notification.Id;
    store.dispatch("userUpdated", notification);
  } else if (
    notificationType == NotificationType.FavoriteUserResponse ||
    notificationType == NotificationType.UserFavoriteMessage
  ) {
    if (!notification.Id && notification.UserId)
      notification.Id = notification.UserId;
    else if (notification.Id && !notification.UserId)
      notification.UserId = notification.Id;
    store.dispatch("handleUserFavoriteResponse", notification);
  } else if (notificationType == NotificationType.ViewStoreUpdate) {
    try {
      EventBus.$emit("handleStoreUpdateNotification", notification);
    } catch (err) {}
  }
}



// WEBPACK FOOTER //
// ./src/lib/pubnub/pubnubListeners.js